// src/pages/Contact.tsx
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Mail, Phone, MapPin, Clock, MessageSquare } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-grow pt-20">
        <div className="container mx-auto px-4 py-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-slate-700">
            Contact Us
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Get In Touch Form */}
            <div className="bg-white/80 rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-semibold mb-4 text-slate-700">
                Get In Touch
              </h2>

              <form
                className="space-y-4"
                action="https://formspree.io/f/movdowyr"  /* your Formspree endpoint */
                method="POST"
              >
                {/* disable Formspree captcha */}
                <input type="hidden" name="_captcha" value="false" />
                {/* customize the email subject */}
                <input
                  type="hidden"
                  name="_subject"
                  value="New message from FirmTitleTB Contact Form"
                />
                {/*
                // optional: redirect after submit
                <input
                  type="hidden"
                  name="_next"
                  value="https://your-domain.com/thank-you"
                />
                */}

                <div className="space-y-2">
                  <Label htmlFor="name">Your Name</Label>
                  <Input
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="email">Email Address</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="message">Message</Label>
                  <textarea
                    id="message"
                    name="message"
                    className="flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    placeholder="How can we help you?"
                  />
                </div>

                <Button
                  type="submit"
                  className="w-full bg-slate-600/70 hover:bg-slate-700/70"
                >
                  Send Message
                </Button>
              </form>

              {/* SMS Opt-In Link */}
              <div className="mt-6 pt-6 border-t border-slate-200">
                <p className="text-sm text-slate-600 mb-3">
                  Prefer text messages? Stay connected via SMS:
                </p>
                <Link
                  to="/sms-opt-in"
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#0057FF] hover:text-[#0046cc] transition-colors"
                >
                  <MessageSquare className="h-4 w-4" />
                  Sign Up for SMS Updates
                </Link>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-white/80 rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-semibold mb-4 text-slate-700">
                Contact Information
              </h2>

              <div className="space-y-4">
                <div className="flex items-start">
                  <Phone className="h-5 w-5 mr-3 text-slate-600/70" />
                  <div>
                    <p className="font-medium text-slate-700">Phone</p>
                    <p className="text-slate-600">(813) 812-4949</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail className="h-5 w-5 mr-3 text-slate-600/70" />
                  <div>
                    <p className="font-medium text-slate-700">Email</p>
                    <p className="text-slate-600">contracts@firmtitletb.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <MapPin className="h-5 w-5 mr-3 text-slate-600/70" />
                  <div>
                    <p className="font-medium text-slate-700">Office</p>
                    <p className="text-slate-600">
                      3502 Henderson Blvd 2nd Floor, Suite 225
                    </p>
                    <p className="text-slate-600">Tampa, FL 33609</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Clock className="h-5 w-5 mr-3 text-slate-600/70" />
                  <div>
                    <p className="font-medium text-slate-700">Business Hours</p>
                    <p className="text-slate-600">
                      Monday - Friday: 9:00 AM - 5:00 PM
                    </p>
                    <p className="text-slate-600">Saturday - Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
